import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'scpi-means-payment',
    templateUrl: './scpi-means-payment.component.html',
    styleUrls: ['./scpi-means-payment.component.scss'],
    standalone: false
})
export class ScpiMeansPaymentComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  options: FormControlOption[] = [
    {
      label: 'En Cash',
      value: 'INITIAL',
      suffix: 'A',
      svg: 'money1.svg',
    },
    {
      label: 'A Crédit',
      value: 'MONTHLY',
      suffix: 'B',
      svg: 'cashback1.svg',
    },
  ];
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
